/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { Milestone } from './Milestone';
import {
    MilestoneFromJSON,
    MilestoneFromJSONTyped,
    MilestoneToJSON,
    instanceOfMilestone,
} from './Milestone';

/**
 * A task assigned to a specific Roblox player for this experience.
 * @export
 * @interface PlayerTaskAssignment
 */
export interface PlayerTaskAssignment {
    /**
     * A short, human-readable display name for the task.
     * @type {string}
     * @memberof PlayerTaskAssignment
     */
    name: string;
    /**
     * A brief description displayed alongside the task title.
     * @type {string}
     * @memberof PlayerTaskAssignment
     */
    subheading: string;
    /**
     * Instructions for how to complete the task.
     * @type {string}
     * @memberof PlayerTaskAssignment
     */
    instructions: string;
    /**
     * Optional assets attached directly to the task.
     * @type {Array<string>}
     * @memberof PlayerTaskAssignment
     */
    assetIds?: Array<string>;
    /**
     * Unique identifier for the task instance.
     * @type {string}
     * @memberof PlayerTaskAssignment
     */
    taskId: string;
    /**
     * Identifier for the catalog entry that defines the assignment.
     * @type {string}
     * @memberof PlayerTaskAssignment
     */
    entryId: string;
    /**
     * 
     * @type {Milestone}
     * @memberof PlayerTaskAssignment
     */
    nextMilestone?: Milestone;
    /**
     * The sum of all the percentContributions for completed milestones if this
task uses milestones. Or, for tasks that aren't milestones, the current
percentage grade in the TaskInstances table for the student.
     * @type {number}
     * @memberof PlayerTaskAssignment
     */
    cumulativePercentage?: number;
}


/**
 * Check if a given object implements the PlayerTaskAssignment interface.
 */
export function instanceOfPlayerTaskAssignment(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "subheading" in value;
    isInstance = isInstance && "instructions" in value;
    isInstance = isInstance && "taskId" in value;
    isInstance = isInstance && "entryId" in value;
    return isInstance;
}

export function PlayerTaskAssignmentFromJSON(json: any): PlayerTaskAssignment {
    return PlayerTaskAssignmentFromJSONTyped(json, false);
}

export function PlayerTaskAssignmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayerTaskAssignment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'name': json['name'],
        'subheading': json['subheading'],
        'instructions': json['instructions'],
        'assetIds': !exists(json, 'assetIds') ? undefined : json['assetIds'],
        'taskId': json['taskId'],
        'entryId': json['entryId'],
        'nextMilestone': !exists(json, 'nextMilestone') ? undefined : MilestoneFromJSON(json['nextMilestone']),
        'cumulativePercentage': !exists(json, 'cumulativePercentage') ? undefined : json['cumulativePercentage'],
    };
}

export function PlayerTaskAssignmentToJSON(value?: PlayerTaskAssignment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'name': value.name,
        'subheading': value.subheading,
        'instructions': value.instructions,
        'assetIds': value.assetIds === undefined ? undefined : value.assetIds,
        'taskId': value.taskId,
        'entryId': value.entryId,
        'nextMilestone': MilestoneToJSON(value.nextMilestone),
        'cumulativePercentage': value.cumulativePercentage,
    };
}

